import { useState, useEffect } from 'react'
import { useDebounce } from 'react-use'

export const useDebounceValue = <T>(
  ms: number,
  fn: () => T,
  deps: unknown[],
) => {
  const [state, setState] = useState<T>(fn())

  useDebounce(() => setState(fn()), ms, deps)

  return state
}

export const useArrayMemo = <T>(next: T[]) => {
  const [value, setValue] = useState(next)

  useEffect(() => {
    if (next.length !== value.length || !next.every((x, i) => x === value[i])) {
      setValue(next)
    }
  }, [value, setValue, next])

  return value
}
